import { render, staticRenderFns } from "./List.vue?vue&type=template&id=f184603e&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=f184603e&prod&lang=scss&scoped=true"
import style1 from "./List.vue?vue&type=style&index=1&id=f184603e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f184603e",
  null
  
)

export default component.exports